import createReactComponent from '../createReactComponent';
export default createReactComponent('message-forward', 'IconMessageForward', [
  [
    'path',
    {
      d: 'M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M13 9l2 2l-2 2', key: 'svg-1' }],
  ['path', { d: 'M15 11h-6', key: 'svg-2' }],
]);
